import { UserSubmitForm } from "../../../utils/helpers/helperMethods/Validations";


export const initialUserFormValues: UserSubmitForm & { comment?: string } = {
  firstName: "",
  lastName: "",
  address1: "",
  jobTitle: "",
  company: "",
  mobile: "",
  phone: "",
  email: "",
  noOfEmployees: "",
  businessType: "",
  revenue: "",
  comment: "",
};
